import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosConfiguracionProyectoResponsablesRequeridosComponent {
  data
  guardando
  idProyecto
  onChange
  onSelect

  mover (valor, item) {
    if (!valor) return
    item.valor = undefined
    valor > 0 ? this.moveElementUp(this.data, item) : this.moveElementDown(this.data, item)
  }

  eliminar (item) {
    this.data.splice(this.data.indexOf(item), 1)
    this.onChange({$event: {detail: this.data}})
  }

  actualizar (data, item) {
    this.mover(data.valor, item)
    this.onChange({$event: {detail: this.data}})
  }

  moveElementUp (array, element) {
    const index = array.indexOf(element)

    if (index === -1 || !array[index - 1]) return

    array.splice(index - 1, 2, array[index], array[index - 1])
  }

  moveElementDown (array, element) {
    const index = array.indexOf(element)

    if (index === -1 || !array[index + 1]) return

    array.splice(index, 2, array[index + 1], array[index])
  }
}

module.component('viaticosConfiguracionProyectoResponsablesRequeridos', {
  controller: ViaticosConfiguracionProyectoResponsablesRequeridosComponent,
  template,
  bindings: {
    idProyecto: '<',
    data: '<',
    guardando: '<',
    onChange: '&',
    onSelect: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/configuracion/proyecto/responsables/requeridos/component.js